<template>
  <div class="desc-container">
    <Row>
      <Col span="12">
        <p class="desc-item"><span class="label">ID：</span>{{ row.Id }}</p>
        <p class="desc-item"><span class="label">所属充电桩ID：</span>{{ row.EquipmentId }}</p>
        <p class="desc-item"><span class="label">模块地址：</span>{{ row.ModuleAddr }}</p>
        <p class="desc-item"><span class="label">所属分组：</span>{{ row.ModuleGroup }}</p>
        <p class="desc-item"><span class="label">组内模块数量：</span>{{ row.ModuleNumInGroup }}</p>
        <p class="desc-item"><span class="label">分配终端号：</span>{{ row.SwitchTo }}</p>
      </Col>
      <Col span="12">
        <p class="desc-item"><span class="label">模块类型：</span>{{ row.ModuleType }}</p>
        <p class="desc-item"><span class="label">模块状态：</span>{{ row.ModuleStatus === 0 ? '关机' : '开机' }}</p>
        <p class="desc-item"><span class="label">故障码：</span>{{ row.FaultCode }}</p>
        <p class="desc-item"><span class="label">设置电压(V)：</span>{{ row.SetVoltage }}</p>
        <p class="desc-item"><span class="label">设置电流(A)：</span>{{ row.SetCurrent }}</p>
      </Col>
      <Col span="12">
        <p class="desc-item"><span class="label">输出电压(V)：</span>{{ row.OutputVoltage }}</p>
        <p class="desc-item"><span class="label">输出电流(A)：</span>{{ row.OutputCurrent }}</p>
      </Col>
      <Col span="12">
        <p class="desc-item"><span class="label">模块温度(℃)：</span>{{ row.ModuleTemp }}</p>
        <p class="desc-item"><span class="label">上报时间：</span>{{ row.ReportTime }}</p>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  name: "ModuleExpand",
  props: {
    row: {
      type: Object,
      required: true
    }
  }
}
</script>
<style scoped>
.desc-container {
	padding: 16px 24px;
	background: #fafafa;
}
.desc-item {
	margin: 8px 0;
	font-size: 14px;
}
.label {
	color: #666;
	display: inline-block;
	width: 140px;
}
</style>
